import React, {useEffect, useState} from "react"
import '../../styles/components/popups/_popup-footer.scss'
import footerGirl from "../../images/footerGirl.png";
import close from '../../images/cross.svg'

const PopupFooter = () => {

    const [closePopup, setClosePopup] = useState(false)

    const setPopupState = async () => {
        setClosePopup(false)
        localStorage.setItem('closedPopUp', 'true')
    }

     useEffect( () => {
         const localStorageItem = localStorage.getItem('closedPopUp')
         if(!localStorageItem) {
             setClosePopup(true)
         }
    }, [])

    return (
        <>
            { closePopup && <div className='popup-footer__bottom-bar'>
                <div className='popup-footer__cta'>
                    <p className='popup-footer__close'>
                        <img
                            src={close}
                            alt='close'
                            height='10px'
                            width='10px'
                            onClick={() => setPopupState()}
                        />
                    </p>
                    <p className='popup-footer__img-w'>
                        <img
                            className='popup-footer__img'
                            src={footerGirl}
                            alt="Girl"
                        />
                    </p>
                    <div className='popup-footer__text'>
                        <p className='popup-footer__title'>Need help writing?</p>
                        <p className='popup-footer__description'>Call +1 888 701 5192 in the USA!</p>
                    </div>
                    <p className='popup-footer__btn-w'>
                        <a
                            href="tel:+18887015192"
                            className="popup-footer__btn"
                        >
                            <div className='popup-footer__call'>
                                <p>phone now</p>
                                <span className='flag-icon flag-icon-us'/>
                                {/* <span className="flare"/> */}
                            </div>
                        </a>
                    </p>
                </div>
            </div>}
        </>
    )
}

export default PopupFooter
